import { motion } from "framer-motion";
import { cn } from "libs/helpers/src/lib/cn";
import { useTranslation } from "react-i18next";

import { Button } from "../../../../atoms";

export const UpcomingBookings = ({
  previewImage,
  title,
}: {
  previewImage: string;
  title: string;
}) => {
  const { t } = useTranslation();

  return (
    <motion.div
      layout
      initial={{ opacity: 0, y: 8, scale: 0.98 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: -8, scale: 0.98 }}
      transition={{ duration: 0.2, ease: "easeOut" }}
      className="flex h-fit w-full flex-col gap-2 overflow-hidden rounded-2xl border border-gray-200 bg-white p-4"
    >
      <div className="flex flex-row items-center justify-between">
        <div className="text-base font-medium text-gray-950">{title}</div>
        <Button intent="link-secondary" className="h-fit text-sm">
          {t("portal.common.viewAll")}
        </Button>
      </div>

      <div className="relative flex w-full flex-row gap-2 overflow-x-visible">
        <img
          src={previewImage}
          alt="preview"
          className={cn("flex size-full object-contain")}
        />
        <img
          src={previewImage}
          alt="preview"
          className={cn("flex size-full object-contain")}
        />
      </div>
    </motion.div>
  );
};
